/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import FormFieldsGroupHeaderComponent from "@Components/UI/Forms/Group/Header";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldComponent from "@Components/UI/Forms/Field";
import DefaultFormButton from "@Components/UI/Forms/Buttons/Default";


import {PasswordResetFormStepType, PasswordResetErrorsInterface} from "@UIPages/NotAuthenticated/PasswordReset";


type PasswordResetFormStep3Props = {
    forwardRef?: React.ForwardedRef<any> | null;
    passwordResetFormStep: PasswordResetFormStepType; passwordResetFormStepHandler(step: number, final?: boolean): void;
    passwordResetFormErrors: PasswordResetErrorsInterface;
    formUserNewPassword: string; formUserNewPasswordHandler(e: React.ChangeEvent<HTMLInputElement> | string): void;
    formUserNewPasswordRepeat: string; formUserNewPasswordRepeatHandler(e: React.ChangeEvent<HTMLInputElement> | string): void;
};

export const PasswordResetFormStep3Component: React.FC<PasswordResetFormStep3Props> = ({
    forwardRef = null,
    passwordResetFormStep, passwordResetFormStepHandler, passwordResetFormErrors,
    formUserNewPassword, formUserNewPasswordHandler,
    formUserNewPasswordRepeat, formUserNewPasswordRepeatHandler
}): JSX.Element | null => {


    const REST_API_REQUEST_STATUS= useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    return (
        <FormFieldsGroupComponent forwardRef={forwardRef} cssClasses={passwordResetFormStep !== 3 ? "disabled" : ""}>

            <FormFieldsGroupFieldsComponent>

                <FormFieldComponent
                    lg={6}
                    fieldValue={formUserNewPassword}
                    fieldValueHandler={e => formUserNewPasswordHandler(e)}
                    fieldType={"password"} fieldLabel={`Hasło`} fieldControlID={`register-form-user-password`}
                    fieldDisabledStatus={passwordResetFormStep !== 3 || !!REST_API_REQUEST_STATUS}
                    fieldError={passwordResetFormErrors?.formUserNewPassword}
                    fieldLegend={`Hasło powinno składać się z minimum 8 znaków, oraz zawierać cyfrę, wielką literę i znak specjalny`}
                />

                <FormFieldComponent
                    lg={6}
                    fieldValue={formUserNewPasswordRepeat}
                    fieldValueHandler={e => formUserNewPasswordRepeatHandler(e)}
                    fieldType={"password"} fieldLabel={`Powtórz Hasło`} fieldControlID={`register-form-user-password-repeat`}
                    fieldDisabledStatus={passwordResetFormStep !== 3 || !!REST_API_REQUEST_STATUS}
                    fieldError={passwordResetFormErrors?.formUserNewPasswordRepeat}
                />

            </FormFieldsGroupFieldsComponent>

            <>
                {passwordResetFormStep === 3 &&
		        <DefaultFormButton
			        buttonText={`Zmień Hasło`}
			        clickHandler={() => passwordResetFormStepHandler(4)}
			        controlId={`password-reset-form-step2-submit`}
			        disabled={!!REST_API_REQUEST_STATUS}
			        cssClasses={`password-reset-form-step-submit`}
		        />
                }
            </>

        </FormFieldsGroupComponent>
    );

};


export default PasswordResetFormStep3Component;
